<!-- Side Overlay-->
<aside id="side-overlay">
  <!-- Side Overlay Scroll Container -->
  <div id="side-overlay-scroll">
    <!-- Side Header -->
    <div class="content-header content-header-fullrow">
      <div class="content-header-section align-parent">
        <!-- Close Side Overlay -->
        <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
        <button type="button" class="btn btn-circle btn-dual-secondary align-v-r" data-toggle="layout"
          data-action="side_overlay_close">
          <i class="fa fa-times text-danger"></i>
        </button>
        <!-- END Close Side Overlay -->

        <!-- User Info -->
        <div class="content-header-item">
          <a class="img-link mr-5" [routerLink]="['/team', authService.currentUser._id]">
            <!-- ./assets/styles/js/codebase.js -->
            <img class="img-avatar img-avatar32" src="assets/img/avatars/company.jpg" alt="">
          </a>
          <a class="align-middle link-effect text-primary-dark font-w600"
            [routerLink]="['/team', authService.currentUser._id]">{{authService.currentUser.firstName}}</a>
        </div>
        <!-- END User Info -->
      </div>
    </div>
    <!-- END Side Header -->

    <!-- Block -->
    <!-- <div class="block pull-r-l">
      <div class="block-header bg-body-light">
        <h3 class="block-title">Tasks Management</h3>
        <div class="block-options">
          <button type="button" class="btn-block-option" data-toggle="block-option" data-action="state_toggle" data-action-mode="demo">
            <i class="si si-refresh"></i>
          </button>
          <button type="button" class="btn-block-option" data-toggle="block-option" data-action="content_toggle"></button>
        </div>
      </div>
      <div class="block-content">
        <p>Quick access to tasks will go here</p>
      </div>
    </div> -->
    <!-- END Block -->

    <div class="content-side">

      <!-- Activity -->
      <div class="block pull-r-l">
        <div class="block-header bg-body-light">
          <h3 class="block-title">
            <i class="fa fa-fw fa-clock-o font-size-default mr-5"></i>Recently Viewed
          </h3>
          <div class="block-options">
            <!-- <button type="button" class="btn-block-option" data-toggle="block-option" data-action="state_toggle" data-action-mode="demo">
              <i class="si si-refresh"></i>
            </button> -->
            <button type="button" class="btn-block-option" data-toggle="block-option" data-action="content_toggle">
              <i class="si si-arrow-up"></i>
            </button>
          </div>
        </div>
        <div class="block-content">

          <ul class="nav-users push" *ngIf="authService.currentUser.userSettings.recentlyViewedItems">
            <li *ngFor="let item of authService.currentUser.userSettings.recentlyViewedItems">
              <a [routerLink]="[item.link, item.objectId]">
                <img class="img-avatar" src="{{item.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';"
                  alt="">{{ item.type }} - {{ item.name }}
                <div class="font-w400 font-size-xs text-muted">{{item.summary}}</div>
              </a>
            </li>
          </ul>

        </div>
      </div>
      <!-- END Side Content -->
    </div>
  </div>
  <!-- END Side Overlay Scroll Container -->
</aside>
<!-- END Side Overlay -->

<!-- Sidebar -->
<!--
                Helper classes

                Adding .sidebar-mini-hide to an element will make it invisible (opacity: 0) when the sidebar is in mini mode
                Adding .sidebar-mini-show to an element will make it visible (opacity: 1) when the sidebar is in mini mode
                    If you would like to disable the transition, just add the .sidebar-mini-notrans along with one of the previous 2 classes

                Adding .sidebar-mini-hidden to an element will hide it when the sidebar is in mini mode
                Adding .sidebar-mini-visible to an element will show it only when the sidebar is in mini mode
                    - use .sidebar-mini-visible-b if you would like to be a block when visible (display: block)
            -->
<nav id="sidebar">
  <!-- Sidebar Scroll Container -->
  <div id="sidebar-scroll">
    <!-- Sidebar Content -->
    <div class="sidebar-content">
      <!-- Side Header -->
      <div class="content-header content-header-fullrow px-10">
        <!-- Mini Mode -->
        <div class="content-header-section sidebar-mini-visible-b">
          <!-- Logo -->
          <span class="content-header-item font-w700 font-size-xl float-left animated fadeIn">
            <!-- <span class="text-primary">bb</span> -->
            <!-- <div class="> -->
            <img class="pl-0" src="/assets/img/logo/FCP_Logo_Wht.png" width="32">
            <!-- <div>SAPPHIRE</div> -->
            <!-- </div> -->
            <!-- <span class="text-dual-primary-dark">c</span>
            <span class="text-primary">b</span> -->
          </span>
          <!-- END Logo -->
        </div>
        <!-- END Mini Mode -->

        <!-- Normal Mode -->
        <div class="content-header-section text-center align-parent sidebar-mini-hidden">
          <!-- Close Sidebar, Visible only on mobile screens -->
          <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
          <button type="button" class="btn btn-circle btn-dual-secondary d-lg-none align-v-r" data-toggle="layout"
            data-action="sidebar_close">
            <i class="fa fa-times text-danger"></i>
          </button>
          <!-- END Close Sidebar -->

          <!-- Logo -->
          <div class="content-header-item">
            <img src="/assets/img/logo/FCP_Logo_Wht.png" width="130">
          </div>
          <!-- END Logo -->
        </div>
        <!-- END Normal Mode -->
      </div>
      <!-- END Side Header -->

      <!-- Side User -->
      <div class="content-side content-side-full content-side-user px-10 align-parent">
        <!-- Visible only in mini mode -->
        <div class="sidebar-mini-visible-b align-v animated fadeIn">
          <img *ngIf="authService.currentUser.photoUrl" class="img-avatar img-avatar32"
            src="{{ authService.currentUser.photoUrl }}" alt="">
          <img *ngIf="!authService.currentUser.photoUrl" class="img-avatar img-avatar32"
            src="assets/img/avatars/company.jpg" alt="">
        </div>
        <!-- END Visible only in mini mode -->

        <!-- Visible only in normal mode -->
        <div class="sidebar-mini-hidden-b text-center">
          <a class="img-link" [routerLink]="['/team', authService.currentUser._id]">
            <img *ngIf="authService.currentUser.photoUrl" class="img-avatar"
              src="{{ authService.currentUser.photoUrl }}" alt="">
            <img *ngIf="!authService.currentUser.photoUrl" class="img-avatar" src="assets/img/avatars/company.jpg"
              alt="">
          </a>
          <ul class="list-inline mt-10">
            <li class="list-inline-item">
              <a class="link-effect text-dual-primary-dark font-size-xs font-w600 "
                [routerLink]="['/team', authService.currentUser._id]">{{ authService.currentUser.firstName }} </a>
            </li>
            <li class="list-inline-item">
              <a class="link-effect text-dual-primary-dark" (click)="setNavbarSetting()">
                <i class="si si-pin"></i>
              </a>
            </li>
          </ul>
        </div>

        <!-- END Visible only in normal mode -->
      </div>
      <!-- END Side User -->

      <!-- Side Navigation -->
      <div class="content-side content-side-full">
        <ul class="nav-main">

          <li *ngIf="this.isUser()">
            <a [routerLink]="['/dashboard']" [routerLinkActive]="'active'" *ngIf="isUser()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="si si-map"></i>
              <span class="sidebar-mini-hide">Dashboard</span>
            </a>
          </li>
          <li *ngIf="this.isManager">
            <a [routerLink]="['/dashboard/manager']" [routerLinkActive]="'active'" *ngIf="isManager()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="si si-globe"></i>
              <span class="sidebar-mini-hide">Team</span>
            </a>
          </li>
          <li *ngIf="this.isSuperAdmin">
            <a [routerLink]="['/dashboard/externalusers']" [routerLinkActive]="'active'" *ngIf="isSuperAdmin()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="si si-phone"></i>
              <span class="sidebar-mini-hide">External Callers</span>
            </a>
          </li>
          <li *ngIf="this.isExternalUser">
            <a [routerLink]="['/ext/dashboard']" [routerLinkActive]="'active'" *ngIf="isExternalUser()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="si si-globe"></i>
              <span class="sidebar-mini-hide">Dashboard</span>
            </a>
          </li>

          <!-- Contact Database -->
          <li class="nav-main-heading" *ngIf="isUser()">
            <span class="sidebar-mini-visible">Co</span>
            <span class="sidebar-mini-hidden">Contacts</span>
          </li>
          <li>
            <a [routerLink]="['/companies']" [routerLinkActive]="'active'" *ngIf="isUser()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-building-o"></i>
              <span class="sidebar-mini-hide">Companies</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/contacts']" [routerLinkActive]="'active'" *ngIf="isUser()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="si si-users"></i>
              <span class="sidebar-mini-hide">People</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/ambassadors']" [routerLinkActive]="'active'" *ngIf="isUser()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="si si-star"></i>
              <span class="sidebar-mini-hide">Ambassadors</span>
            </a>
          </li>

          <!-- Velocity -->
          <!-- <li class="nav-main-heading" *ngIf="isUser()">
            <span class="sidebar-mini-visible">VE</span>
            <span class="sidebar-mini-hidden">Velocity</span>
          </li>
          <li>
            <a [routerLink]="['/projects/velocity/opportunities']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }"
              [routerLinkActiveOptions]="{ exact: true }" *ngIf="isUser()">
              <i class="fa fa-ticket"></i>
              <span class="sidebar-mini-hide">Opportunities</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/projects/velocity/deals']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }"
              *ngIf="isUser()">
              <i class="fa fa-briefcase"></i>
              <span class="sidebar-mini-hide">Deals</span>
            </a>
          </li> -->
          <!-- <li>
            <a [routerLink]="['/projects/velocity']" [routerLinkActive]="'active'" *ngIf="isUser()" [routerLinkActiveOptions]="{ exact: true }">
              <i class="fa fa-vimeo"></i>
              <span class="sidebar-mini-hide">Velocity</span>
            </a>
          </li> -->
          
          <!-- Projects  -->
          <li class="nav-main-heading" *ngIf="isUser()">
            <span class="sidebar-mini-visible">DM</span>
            <span class="sidebar-mini-hidden">Deal Management</span>
          </li>
          <li>
            <a [routerLink]="['/projects/opportunities']" [routerLinkActive]="'active'" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }" *ngIf="isUser()">
              <i class="fa fa-ticket"></i>
              <span class="sidebar-mini-hide">Opportunities</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/projects']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" data-toggle="layout"  data-action="sidebar_close_mobile"
              *ngIf="isUser()">
              <i class="fa fa-briefcase"></i>
              <span class="sidebar-mini-hide">Deals</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/projects/console']" [routerLinkActive]="'active'" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }" *ngIf="isUser()">
              <i class="fa fa-address-card-o"></i>
              <span class="sidebar-mini-hide">Console</span>
            </a>
          </li>
          <li *ngIf="this.isExternalUser">
            <a [routerLink]="['/ext/console']" [routerLinkActive]="'active'" *ngIf="isExternalUser()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="fa fa-address-card-o"></i>
              <span class="sidebar-mini-hide">Console</span>
            </a>
          </li>

          <!-- Reporting  -->
          <li class="nav-main-heading" *ngIf="isUser()">
            <span class="sidebar-mini-visible">RE</span>
            <span class="sidebar-mini-hidden">Reporting</span>
          </li>
          <li>
            <a [routerLink]="['/reports']" [routerLinkActive]="'active'" *ngIf="isUser()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-filter"></i>
              <span class="sidebar-mini-hide">Reports</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/upload']" [routerLinkActive]="'active'" *ngIf="isAdmin()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-cloud-upload"></i>
              <span class="sidebar-mini-hide">Data Upload</span>
            </a>
          </li>

          <!-- Events  -->
          <li class="nav-main-heading" *ngIf="isUser()">
            <span class="sidebar-mini-visible">EV</span>
            <span class="sidebar-mini-hidden">Events Management</span>
          </li>
          <li>
            <a [routerLink]="['/events']" [routerLinkActive]="'active'" *ngIf="isUser()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-users"></i>
              <span class="sidebar-mini-hide">Events</span>
            </a>
          </li>

          <!-- Admin / User Management Section -->
          <li class="nav-main-heading" *ngIf="isManager()">
            <span class="sidebar-mini-visible">Ad</span>
            <span class="sidebar-mini-hidden">Administration</span>
          </li>
          <li>
            <a [routerLink]="['/team']" [routerLinkActive]="'active'" *ngIf="isManager()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-building-o"></i>
              <span class="sidebar-mini-hide">Team</span>
            </a>
          </li>
          <!-- <li>
            <a [routerLink]="['/admin/guests']" [routerLinkActive]="'active'" *ngIf="isAdmin()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="fa fa-user-o"></i>
              <span class="sidebar-mini-hide">Guests</span>
            </a>
          </li> -->

          <li>
            <a [routerLink]="['/admin']" [routerLinkActive]="'active'" *ngIf="isAdmin()" data-toggle="layout"  data-action="sidebar_close_mobile"
              [routerLinkActiveOptions]="{ exact: true }">
              <i class="si si-users"></i>
              <span class="sidebar-mini-hide">Users</span>
            </a>
          </li>

          <!-- Client Section -->
          <li class="nav-main-heading" *ngIf="isClient()">
            <span class="sidebar-mini-visible">Cl</span>
            <span class="sidebar-mini-hidden">Client</span>
          </li>
          <li>
            <a [routerLink]="['/client/approval']" [routerLinkActive]="'active'" *ngIf="isClient()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-check"></i>
              <span class="sidebar-mini-hide">Approvals</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/client/status']" [routerLinkActive]="'active'" *ngIf="isClient()" data-toggle="layout"  data-action="sidebar_close_mobile">
              <i class="fa fa-briefcase"></i>
              <span class="sidebar-mini-hide">Project Status</span>
            </a>
          </li>

        </ul>
      </div>
      <!-- END Side Navigation -->
    </div>
    <!-- Sidebar Content -->
  </div>
  <!-- END Sidebar Scroll Container -->
</nav>
<!-- END Sidebar -->



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/navbar/navbar.component.html